import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../services/presupuesto.service";

const initialState = {
    presupuestos: [],
    presupuesto: null,
    isLoading: false,
    isError: false,
    message: '',
    currentPage: 1,
    totalRows: 0,
    numeroSiguienteFactura: null, // Campo para almacenar el siguiente número de presupuesto
};


export const getPresupuestos = createAsyncThunk(
    "presupuestos/getPresupuestos",
    async (data, thunkAPI) => {
        try {
            return await service.getAllPresupuestos(data);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const createPresupuesto = createAsyncThunk(
    "presupuesto/create",
    async (presupuestoData, thunkAPI) => {
        try {
            return await service.createPresupuesto(presupuestoData);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const updatePresupuesto = createAsyncThunk(
    "presupuesto/update",
    async (presupuestoData, thunkAPI) => {
        try {
            return await service.updatePresupuesto(presupuestoData);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);
export const deletePresupuesto = createAsyncThunk(
    "presupuesto/delete",
    async (id, thunkAPI) => {
        try {
            return await service.deletePresupuesto(id);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Acción para obtener una factura por ID
export const getPresupuestoById = createAsyncThunk(
    'presupuestos/getPresupuestoById',
    async (id, thunkAPI) => {
        try {
            return await service.getPresupuestoById(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);



const presupuestoSlice = createSlice({
    name: "presupuestos",
    initialState,
    reducers: {
            reset: (state) => initialState,
        },
    extraReducers: (builder) => {
        builder
            .addCase(getPresupuestos.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPresupuestos.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.presupuestos = action.payload.data; // Asegúrate de que esto coincida con la estructura de tu respuesta
                state.currentPage = action.payload.pagination.currentPage;
                state.totalRows = action.payload.pagination.totalRows;
            })
            .addCase(getPresupuestos.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(createPresupuesto.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createPresupuesto.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                // Puedes agregar el nuevo presupuesto a la lista si es necesario
            })
            .addCase(createPresupuesto.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(updatePresupuesto.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updatePresupuesto.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                // Actualiza el presupuesto en la lista si es necesario
            })
            .addCase(updatePresupuesto.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(deletePresupuesto.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deletePresupuesto.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.presupuestos = state.presupuestos.filter(
                    (presupuesto) => presupuesto.id !== action.payload.id
                ); // Elimina el presupuesto de la lista
            })
            .addCase(deletePresupuesto.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getPresupuestoById.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPresupuestoById.fulfilled, (state, action) => { 
                state.isLoading = false;
                state.isError = false;
                state.presupuesto = action.payload; // Guarda el presupuesto obtenido por ID
            })
            .addCase(getPresupuestoById.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error al cargar el presupuesto';
            });
    },
});

export const { reset } = presupuestoSlice.actions;
export default presupuestoSlice.reducer;

